import React from 'react';
export default React.createContext(null);


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-transition-group/esm/TransitionGroupContext.js
// module id = 316
// module chunks = 0